import React from 'react';
import moment from 'moment';
import { Button, Table } from 'antd/lib';
import * as Icons from '@ant-design/icons';

class TablaMostrarRendiciones extends React.Component {
  render() {
    const colums = [
      {
        title: 'Fecha Inicio',
        dataIndex: 'fechaInicio',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
      },
      {
        title: 'Fecha Fin',
        dataIndex: 'fechaFin',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
      },
      {
        title: 'Organismo',
        dataIndex: ['organismo', 'nombre'],
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              size="small"
              icon={<Icons.FileSearchOutlined />}
              type="primary"
              onClick={() => this.props.verRendicion(record._id)}
            >
              Ver
            </Button>
          </span>
        ),
      },
    ];

    return (
      <div>
        <Table
          rowKey={'_id'}
          bordered
          pagination={false}
          style={{ maxWidth: 900, marginLeft: '10%', marginTop: 20 }}
          dataSource={this.props.data}
          columns={colums}
        />
      </div>
    );
  }
}

export default TablaMostrarRendiciones;
